import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCameraOff"><Path fillRule="evenodd" clipRule="evenodd" d="M9.09861 3L7.09861 6H2V21H22V6H16.9014L14.9014 3H9.09861ZM9.99833 10.4393L12 12.441L14.0017 10.4393L15.0623 11.5L13.0607 13.5017L15.0607 15.5017L14 16.5623L12 14.5623L10 16.5623L8.93934 15.5017L10.9393 13.5017L8.93767 11.5L9.99833 10.4393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraOff;
